var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      title: _vm.$t("label_essweb_punchRecord_list_dialog_viewPunchTitle"),
      width: "680",
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.isLoading ? _c("noContent") : _vm._e(),
            !_vm.isLoading
              ? _c(
                  "v-form",
                  { ref: "form", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("AutoComplete", {
                              attrs: {
                                label:
                                  "label_essweb_punchRecord_list_dialog_staffLabel",
                                readonly: "",
                                chips: "",
                                avatar: "",
                                "small-chips": "",
                                "two-line": "",
                                items: _vm.users,
                                "item-value": "uuid",
                                "item-text": "preferred_name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection.avatar",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            src: data.item.staff_avatar,
                                            left: "",
                                            isTemp: data.item.is_temp,
                                            staff_name:
                                              data.item.preferred_name,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                data.item.preferred_name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4228236290
                              ),
                              model: {
                                value: _vm.user,
                                callback: function ($$v) {
                                  _vm.user = $$v
                                },
                                expression: "user",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_dialog_dateLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                dense: "",
                                "single-line": "",
                                value: _vm.$getDateTime(
                                  _vm.PunchRecordData.punch_utc_datetime,
                                  "YYYY/MM/DD"
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_dialog_timeLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                dense: "",
                                "single-line": "",
                                value: _vm.$getDateTime(
                                  _vm.PunchRecordData.punch_utc_datetime,
                                  "HH:mm"
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_siteNameLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                dense: "",
                                "single-line": "",
                                value: _vm.$getCommonLangValue(
                                  _vm.PunchRecordData.site_name
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_dialog_punchSourceLabel"
                                  )
                                )
                              ),
                            ]),
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  items: [
                                    "label_essweb_punchRecord_list_appLabel",
                                    "label_essweb_punchRecord_list_dkjLabel",
                                  ],
                                  readonly: "",
                                  "single-line": "",
                                  height: 27,
                                  multiple: "",
                                  "menu-props": {
                                    offsetY: true,
                                    transition: "slide-y-transition",
                                    rounded: true,
                                    contentClass: "elevation-4",
                                  },
                                  "append-icon": "",
                                  dense: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "no-data",
                                      fn: function () {
                                        return [_c("noContent")]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "item",
                                      fn: function (ref) {
                                        var item = ref.item
                                        var index = ref.index
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item))),
                                          ]),
                                        ]
                                      },
                                    },
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var item = ref.item
                                        var index = ref.index
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.$t(item))),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3176410697
                                ),
                                model: {
                                  value: _vm.PunchRecordData.hitCard,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.PunchRecordData,
                                      "hitCard",
                                      $$v
                                    )
                                  },
                                  expression: "PunchRecordData.hitCard",
                                },
                              },
                              [_vm._v(" > ")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_criteriaLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                dense: "",
                                "single-line": "",
                                value: Number(
                                  _vm.PunchRecordData.punch_criteria_matched
                                )
                                  ? _vm.$t(
                                      "message_essweb_punchRecord_list_tip_criteriaMatchedLabel"
                                    )
                                  : _vm.$t(
                                      "message_essweb_punchRecord_list_tip_criteriaNotMatchedLabel"
                                    ),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "prepend-inner",
                                    fn: function () {
                                      return [
                                        _c("svg-icon", {
                                          attrs: {
                                            className: "mt-1",
                                            size: "26",
                                            fill: "transparent",
                                            iconClass: Number(
                                              _vm.PunchRecordData
                                                .punch_criteria_matched
                                            )
                                              ? "Done"
                                              : "Alert",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                956677831
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm.PunchRecordData.source &&
                        Number(_vm.PunchRecordData.source) == 0
                          ? _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                  cols: "12",
                                },
                              },
                              [
                                _c(
                                  "v-container",
                                  {
                                    staticClass:
                                      "grey lighten-4 rounded-lg pa-2 ma-0",
                                    attrs: { fluid: "" },
                                  },
                                  [
                                    _c(
                                      "v-container",
                                      {
                                        staticClass:
                                          "pa-0 ma-0 d-flex flex-row my-3",
                                        attrs: { fluid: "" },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "transparent flex-shrink-1",
                                            attrs: { width: "50%" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_site_form_longtitudeLabel"
                                                  )
                                                ) +
                                                ":" +
                                                _vm._s(
                                                  _vm.PunchRecordData.longitude
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "transparent flex-shrink-1",
                                            attrs: { width: "50%" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_site_form_latitudeLabel"
                                                  )
                                                ) +
                                                ":" +
                                                _vm._s(
                                                  _vm.PunchRecordData.latitude
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-container",
                                      {
                                        staticClass:
                                          "pa-0 ma-0 rounded-lg mrc-border-solid scroll_content_no",
                                        staticStyle: { position: "relative" },
                                        attrs: { fluid: "" },
                                      },
                                      [
                                        _c(
                                          "GmapMap",
                                          {
                                            ref: "punchmap",
                                            staticStyle: {
                                              width: "100%",
                                              height: "300px",
                                            },
                                            attrs: {
                                              center: _vm.center,
                                              zoom: 18,
                                              options: {
                                                zoomControl: false,
                                                mapTypeControl: false,
                                                scaleControl: false,
                                                streetViewControl: false,
                                                rotateControl: false,
                                                keyboardShortcuts: false,
                                                gestureHandling: "greedy",
                                                fullscreenControl: false,
                                                disableDefaultUi: false,
                                              },
                                              "map-type-id": "roadmap",
                                            },
                                          },
                                          [
                                            _c("GmapMarker", {
                                              attrs: {
                                                option: {
                                                  animation: "drop",
                                                  shape: "circle",
                                                },
                                                position: _vm.markers,
                                                clickable: true,
                                                icon: _vm.makericon,
                                                draggable: false,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setCenter(
                                                    _vm.markers
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_dialog_tagLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-select", {
                              attrs: {
                                items: [
                                  "label_essweb_punchRecord_list_tag_workFromHomeLabbel",
                                  "label_essweb_punchRecord_list_tag_fieldServiceLabel",
                                ],
                                readonly: "",
                                "single-line": "",
                                multiple: "",
                                "menu-props": {
                                  offsetY: true,
                                  transition: "slide-y-transition",
                                  rounded: true,
                                  contentClass: "elevation-4",
                                },
                                chips: "",
                                "append-icon": "",
                                dense: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "no-data",
                                    fn: function () {
                                      return [_c("noContent")]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var item = ref.item
                                      var index = ref.index
                                      return [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              "text-color": "white",
                                              color: _vm.$getTagColors(
                                                _vm.$card_line_colors,
                                                item ==
                                                  "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                                  ? "is_work_from_home_1"
                                                  : "is_out_of_office_1"
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.$t(item)) + " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                381570030
                              ),
                              model: {
                                value: _vm.PunchRecordData.tag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.PunchRecordData, "tag", $$v)
                                },
                                expression: "PunchRecordData.tag",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.PunchRecordData.attachments
                          ? _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                  cols: "12",
                                },
                              },
                              [
                                _c(
                                  "v-sheet",
                                  { staticClass: "text--secondary" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_punchRecord_list_dialog_attachmentLabel"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c("ImgDragUpdate", {
                                  attrs: {
                                    defaultImageList:
                                      _vm.PunchRecordData.attachments,
                                    disabled: "",
                                    closePop: _vm.closePop,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_dialog_messageLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                dense: "",
                                "single-line": "",
                                value: _vm.PunchRecordData.remarks,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }